import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { titleCase } from "../../lib/format";
import type { ListResponse, User } from "../../lib/types";
import { EmptyState, PageHeader, Sheet, Skeleton, Table, Td, Th, Tr } from "../../components/ui";

const ROLE_DESCRIPTIONS: Record<string, string> = {
  owner: "Full control, including billing and the team",
  admin: "Full control except closing the account",
  developer: "API keys, webhooks and transactions",
  viewer: "Read-only access",
};

export function Team() {
  const team = useQuery({
    queryKey: ["team"],
    queryFn: () => api.get<ListResponse<User>>("/api/dashboard/team"),
  });

  const rows = team.data?.data ?? [];

  return (
    <>
      <PageHeader
        eyebrow="Account"
        title="Team"
        description="People who can sign in to this merchant account."
      />

      <Sheet className="settle settle-1 overflow-hidden">
        {team.isLoading ? (
          <Skeleton rows={4} />
        ) : rows.length === 0 ? (
          <EmptyState title="No team members" />
        ) : (
          <Table>
            <thead>
              <tr>
                <Th>Name</Th>
                <Th>Email</Th>
                <Th>Role</Th>
                <Th>Email verified</Th>
              </tr>
            </thead>
            <tbody>
              {rows.map((user) => (
                <Tr key={user.id}>
                  <Td>{user.full_name}</Td>
                  <Td className="text-ink-muted">{user.email}</Td>
                  <Td>
                    <span className="text-ink">{titleCase(user.role)}</span>
                    <span className="mt-0.5 block text-[11.5px] text-ink-faint">
                      {ROLE_DESCRIPTIONS[user.role]}
                    </span>
                  </Td>
                  <Td className="text-ink-muted">{user.email_verified ? "Yes" : "Not yet"}</Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        )}
      </Sheet>
    </>
  );
}
